const config = {
  devApiUrl: process.env.REACT_APP_USE_LOCAL ? "http://localhost:3001" : "https://8brjio6n34.execute-api.us-west-2.amazonaws.com/dev",
  prodApiUrl: "https://56lx56i9g4.execute-api.us-west-2.amazonaws.com/prod"
};

const dev = {
  s3: {
    REGION: "us-west-2",
    BUCKET: "eventify-template-test-d-serverlessdeploymentbuck-v5o9a2v88bcl"
  },
  apiGateway: {
    REGION: "us-west-2",
    URL: config.devApiUrl
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_h8qo14sfe",
    APP_CLIENT_ID: "71ebdg0pn1qdc1rdupp2co2q3m",
    IDENTITY_POOL_ID: "us-west-2:0bf6109f-9cf4-4c2b-a8e4-04f0eae459a7"
  }
};

const prod = {
  s3: {
    REGION: "us-west-2",
    BUCKET: "eventify-template-test-d-serverlessdeploymentbuck-v5o9a2v88bcl"
  },
  apiGateway: {
    REGION: "us-west-2",
    URL: config.prodApiUrl
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_h8qo14sfe",
    APP_CLIENT_ID: "71ebdg0pn1qdc1rdupp2co2q3m",
    IDENTITY_POOL_ID: "us-west-2:0bf6109f-9cf4-4c2b-a8e4-04f0eae459a7"
  }
};

// Default to dev if not set
const envConfig = process.env.REACT_APP_STAGE === 'prod'
  ? prod
  : dev;

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...envConfig,
  ...config
};
